import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Avatar from './Avatar';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand" aria-label="YesNeDni — Accueil" onClick={() => setMenuOpen(false)}>
          <img
            src={`${process.env.PUBLIC_URL}/logo/ynd-monogram-gold-png-transparent.png`}
            alt=""
            className="navbar-logo"
          />
          <span className="navbar-brand-text">YesNeDni</span>
        </Link>

        <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu" aria-expanded={menuOpen}>
          <span /><span /><span />
        </button>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/opportunites"  className={isActive('/opportunites')}  onClick={() => setMenuOpen(false)}>Opportunités</Link>
          <Link to="/masterclasses" className={isActive('/masterclasses')} onClick={() => setMenuOpen(false)}>Savoirs</Link>
          <Link to="/mentors"       className={isActive('/mentors')}       onClick={() => setMenuOpen(false)}>Mentors</Link>

          {user ? (
            <>
              {user.role === 'admin' && (
                <Link to="/admin/tableau-de-bord" className={`navbar-btn outline ${isActive('/admin/tableau-de-bord')}`} onClick={() => setMenuOpen(false)}>
                  Tableau de bord
                </Link>
              )}
              <Link to="/profil" className={`navbar-avatar-link ${isActive('/profil')}`} onClick={() => setMenuOpen(false)} aria-label="Mon profil">
                <Avatar user={user} size="sm" />
              </Link>
              <button className="navbar-btn danger" onClick={handleLogout}>Déconnexion</button>
            </>
          ) : (
            <>
              <Link to="/login"      className="navbar-btn outline"  onClick={() => setMenuOpen(false)}>Connexion</Link>
              <Link to="/inscription" className="navbar-btn primary" onClick={() => setMenuOpen(false)}>S'inscrire</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
